var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "#00247d"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 300,300 M 300,0 L 0,300",
    stroke: "#fff",
    strokeWidth: 60
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 L 300,300 M 300,0 L 0,300",
    stroke: "#cf142b",
    strokeWidth: 40
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 150,150 v -30 L 30,0 H 0 z h 30 L 300,30 V 0 z v 30 L 270,300 H 300 z h -30 L 0,270 V 300 z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 150,0 V 300 M 0,150 H 300",
    stroke: "#fff",
    strokeWidth: 100
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 150,0 V 300 M 0,150 H 300",
    stroke: "#cf142b",
    strokeWidth: 60
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.e9d1fe1faf9d7fbe882ceed8437237e0.svg";
export { ForwardRef as ReactComponent };